import moment from 'moment'

const state = {
  now: moment(),
}

const getters = {
  currentTime: (state) => {
    return state.now
  },
}

const actions = {
  startNowTimer({ commit }) {
    setInterval(() => {
      commit('updateTime')
    }, 1000)
  },
  updateNow({ commit }) {
    commit('updateTime')
  },
}

const mutations = {
  updateTime(state) {
    state.now = moment()
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
